var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { getAutomation } from '@citrus/runtime';
import { css as emotionCss } from 'emotion';
import { staticDividerActive, staticDividerInactive } from '../styles';
import { staticDividerActive as staticDividerActiveCitrus2022, staticDividerInactive as staticDividerInactiveCitrus2022, } from '../styles/citrus2022';
import { Styled } from './Sortable.styled';
import { useTheme } from '@citrus/user';
var StaticGroup = function (_a) {
    var automationId = _a.automationId, active = _a.active, children = _a.children, _b = _a.colSpan, colSpan = _b === void 0 ? 1 : _b, item = _a.item, index = _a.index, _c = _a.__TYPE, __TYPE = _c === void 0 ? 'StaticGroup' : _c, onClick = _a.onClick;
    var isCitron = useTheme().citrus2022;
    return (React.createElement(React.Fragment, null,
        React.createElement(Styled.StaticDivider, __assign({}, getAutomation(automationId, 'static-divider')),
            React.createElement(Styled.StaticColumn, __assign({}, getAutomation(automationId, 'static-column'), { className: active
                    ? emotionCss(isCitron ? staticDividerActiveCitrus2022 : staticDividerActive)
                    : emotionCss(isCitron ? staticDividerInactiveCitrus2022 : staticDividerInactive), colSpan: colSpan, onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(index); } }), item.title)),
        active ? children : null));
};
StaticGroup.defaultProps = {
    __TYPE: 'StaticGroup',
};
export default StaticGroup;
